<a *ngIf="brewery"
  [routerLink]="['/brewery', brewery.slug]"
  class="brewery-card"
  [attr.aria-label]="brewery.name">

  <!-- Logo -->
  <div class="brewery-card__logo-wrap">
    <img
      [src]="brewery.logoUrl"
      [alt]="'DrinkHopping - ' + brewery.name"
      class="brewery-card__logo"
    />
  </div>

  <!-- Hover overlay -->
  <div class="brewery-card__overlay" aria-hidden="true">
    <span class="brewery-card__name">{{ brewery.name }}</span>

    <span *ngIf="brewery.breweryType" class="brewery-card__type">
      {{ brewery.breweryType.name }}
    </span>

    <p *ngIf="brewery.description" class="brewery-card__desc">
      {{ brewery.description }}
    </p>

    <span class="brewery-card__cta">
      Ver cervecería
      <svg xmlns="http://www.w3.org/2000/svg" class="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3"/>
      </svg>
    </span>
  </div>

</a>
